import React from 'react';
import { Tooltip } from 'antd';

import type { CycleCallback } from '@/components/ui/Timeline';
import { dayjsToSeconds, formatTime } from '@/components/ui/Timeline/utils/time-conversions';

import { StretchAnchor } from './styles';

interface StretchHintProps {
	tlidName: string;
	stretch: CycleCallback;
	rulerDuration: number;
}

export function StretchHint({ tlidName, stretch, rulerDuration }: Readonly<StretchHintProps>): JSX.Element {
	const start = dayjsToSeconds(stretch.start_time);
	const end = dayjsToSeconds(stretch.end_time);

	const interval = `${formatTime(start)} - ${formatTime(end)}`;
	const startRatio = start / rulerDuration;
	const widthRatio = (end - start) / rulerDuration;

	const title = (
		<>
			<div>{tlidName}</div>
			<div>{interval}</div>
		</>
	);

	return (
		<Tooltip open title={title}>
			<StretchAnchor startRatio={startRatio} widthRatio={widthRatio} />
		</Tooltip>
	);
}
